import { createFileRoute } from '@tanstack/react-router';
import PublicNotices from '@pages/PublicNotices/PublicNotices';
import { z } from 'zod';

const publicNoticesSearchSchema = z.object({
  district: z.string().optional().catch(undefined),
  state: z.string().optional().catch(undefined),
  page: z.coerce.number().int().positive().optional().catch(undefined),
  search: z.string().optional().catch(undefined),
});

export const Route = createFileRoute('/public-notices')({
  validateSearch: publicNoticesSearchSchema.parse,
  component: PublicNotices,
});
